import en from './locales/en';
import es from './locales/es';
import ca from './locales/ca';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { BACKEND_URL_BASE } from '../config';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      ca: { translation: ca },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'ca'],
    interpolation: {
      escapeValue: false,
    },
    debug: BACKEND_URL_BASE.includes('localhost'),
  });

const supportedLanguages: Record<string, string> = {
  en: 'English',
  es: 'Español',
  ca: 'Català',
};

export { supportedLanguages };
export default i18n;
